import { ElementType, lazy } from "react";
// TODO: Add lazy loading of each page element when development is complete
import ManageOrganization from "../pages/admin/organization/ManageOrganization";
import OrganizationDetails from "../pages/admin/organization/OrganizationDetails";
import OrganizationList from "../pages/admin/organization/OrganizationList";
import KeycloakSignIn from "../pages/auth/KeycloakSignIn";
import AttendanceManagement from "../pages/organization/contractual/AttendanceManagement/AttendanceManagement";
import KPIList from "../pages/organization/contractual/KPISetup/KPIList";
import KPISetup from "../pages/organization/contractual/KPISetup/KPISetup";
import ManageKPI from "../pages/organization/contractual/KPISetup/ManageKPI";
import LeaveManagement from "../pages/organization/contractual/LeaveManagement/LeaveManagement";
import KPIBatchDetails from "../pages/organization/contractual/Payroll/KPIBatchDetails";
import PayrollBatchDetails from "../pages/organization/contractual/Payroll/PayrollBatchDetails";
import PayrollList from "../pages/organization/contractual/Payroll/PayrollList";
import SalarySlabList from "../pages/organization/contractual/SalarySlab/SalarySlabList";
import ShiftEmployees from "../pages/organization/contractual/ShiftManagement/ShiftEmployees";
import ShiftEmployeesView from "../pages/organization/contractual/ShiftManagement/ShiftEmployeesView";
import ShiftList from "../pages/organization/contractual/ShiftManagement/ShiftList";
import Dashboard from "../pages/organization/dashboard/Dashboard";
import JobList from "../pages/organization/job/JobList";
import ManageJob from "../pages/organization/job/ManageJob";
import Messages from "../pages/organization/messages/Messages";
import KPIPerformanceDetails from "../pages/organization/myProjects/_components/KPIPerformanceDetails";
import JobDetails from "../pages/organization/myProjects/JobDetails";
import MyProjectDetails from "../pages/organization/myProjects/MyProjectDetails";
import MyProjectList from "../pages/organization/myProjects/MyProjectList";
import MyProjectShiftList from "../pages/organization/myProjects/MyProjectShiftList";
import Notification from "../pages/organization/notification/Notification";
import SPayWallet from "../pages/organization/payment/Payment";
import ProposalDetails from "../pages/organization/proposal/ProposalDetails";
import ProposalList from "../pages/organization/proposal/ProposalList";
import ChangePassword from "../pages/organization/settings/_componnents/ChangePassword";
import Settings from "../pages/organization/settings/Settings";
import SurveyDataDetails from "../pages/organization/survey/surveyData/SurveyDataDetails";
import SurveyDataDetailsSingle from "../pages/organization/survey/surveyData/SurveyDataDetailsSingle";
import SurveyDataList from "../pages/organization/survey/surveyData/SurveyDataList";
import DetailsTemplate from "../pages/organization/survey/templates/DetailsTemplate";
import ManageTemplate from "../pages/organization/survey/templates/ManageTemplate";
import TemplatesList from "../pages/organization/survey/templates/TemplatesList";
import { Role } from "../types/common";
const NotFound = lazy(() => import("../pages/NotFound"));
// const SignIn = lazy(() => import("../pages/auth/SignIn"));

export interface RouteType {
  path: string;
  element: ElementType;
  roles: Role[];
  name?: string;
  props?: Record<string, any>;
}

// auth routers
export const sidebarRouters: RouteType[] = [
  // admin
  {
    path: "/admin/dashboard",
    element: Dashboard,
    roles: ["admin"],
  },
  {
    path: "/admin/organizations/list",
    element: OrganizationList,
    roles: ["admin"],
  },
  {
    path: "/admin/organizations/list/add",
    element: ManageOrganization,
    roles: ["admin"],
  },
  {
    path: "/admin/organizations/list/view/:id",
    element: OrganizationDetails,
    roles: ["admin"],
  },
  // organization
  {
    path: "/organization/dashboard",
    element: Dashboard,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/job-list",
    element: JobList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/job-list/add",
    element: ManageJob,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/job-list/update/:id",
    element: ManageJob,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/job-list/view/:id",
    element: ManageJob,
    roles: ["organization_admin"],
    props: { type: "view" },
  },
  {
    path: "/organization/proposals",
    element: ProposalList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/proposals/details/:id",
    element: ProposalDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/my-projects",
    element: MyProjectList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/my-projects/details/:id",
    element: MyProjectDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/my-projects/shift-list",
    element: MyProjectShiftList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/my-projects/details/:id/:memberId",
    element: JobDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/my-projects/details/:id/:jobId/:kpiId",
    element: KPIPerformanceDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/messages",
    element: Messages,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/survey-data-list",
    element: SurveyDataList,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates/survey-data-details/:id",
    element: SurveyDataDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates/survey-data-details/single-list/:id",
    element: SurveyDataDetailsSingle,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates/survey-data-details/:template_id/:member_id",
    element: SurveyDataDetailsSingle,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates",
    element: TemplatesList,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates/add",
    element: ManageTemplate,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates/update/:id",
    element: ManageTemplate,
    roles: ["organization_admin"],
  },
  {
    path: "/organizations/survey/templates/details/:id",
    element: DetailsTemplate,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/settings",
    element: Settings,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/settings/change-password",
    element: ChangePassword,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/notification",
    element: Notification,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/payment",
    element: SPayWallet,
    roles: ["organization_admin"],
  },

  // ------ API's for Contractual ------
  {
    path: "/organization/contractual/salary-slab",
    element: SalarySlabList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/shift-management",
    element: ShiftList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/shift-management/employees/:id",
    element: ShiftEmployees,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/shift-management/view/:id",
    element: ShiftEmployeesView,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/kpi-setup",
    element: KPISetup,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/kpi-setup/kpis/:id",
    element: KPIList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/kpi-setup/add",
    element: ManageKPI,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/kpi-setup/edit/:id",
    element: ManageKPI,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/leave-management",
    element: LeaveManagement,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/payroll",
    element: PayrollList,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/payroll/payroll-details/:id",
    element: PayrollBatchDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/payroll/kpi-details/:id",
    element: KPIBatchDetails,
    roles: ["organization_admin"],
  },
  {
    path: "/organization/contractual/attendance-management",
    element: AttendanceManagement,
    roles: ["organization_admin"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  // {
  //   path: "/admin/login",
  //   element: AdminLogin,
  // },
  // {
  //   path: "/organization/login",
  //   element: OrganizationLogin,
  // },
  {
    path: "/sign-in",
    element: KeycloakSignIn,
  },
  {
    path: "/404",
    element: NotFound,
  },
  {
    path: "*",
    element: NotFound,
  },
];
